/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to control a dashboard instance behaviour
 */
define([], () => {
	class InternalAPI {
		/**
		 * @description Only used for our internal API.  Should not be used unless absolutely necessary and Ok'ed by code owners.
		 * @deprecated
		 */
		getBoardModel() { }
	}

	return InternalAPI;
});
